<h2 class="main-title text-center">{{ 'CUSTOMIZATION.SHORTS.TITLE' | translate }}</h2>

<div class="row m-0 my-5 align-items-center justify-content-center">
  <div class="col-12 col-md-6 svg-container">
    <div class="svg-logo">
      <div inlineSVG="assets/img/customize/short.svg" #svgContainer></div>
      <img [src]="shortSelections.logoPath" class="position-absolute logo" />
    </div>
  </div>

  <div class="col-12 col-md-6 mt-4 mt-md-0 px-4">
    <div class="card p-4">
      <div class="mb-4">
        <label class="form-label">{{ 'CUSTOMIZATION.SHORTS.COLOR' | translate }}</label>
        <div class="d-flex flex-wrap gap-2" id="shortColor">
          <span
            [id]="color + '-short'"
            *ngFor="let color of colors"
            [ngStyle]="{ background: color }"
            class="color-circle"
            [ngClass]="{ active: shortSelections.color === color }"
            (click)="applyColorToSvg(color)"
          ></span>
        </div>
        <div *ngIf="hasError('SHORT.COLOR_REQUIRED')" class="text-danger mt-2">
          {{ 'CUSTOMIZATION.VALIDATION.SHORT_COLOR_REQUIRED' | translate }}
        </div>
      </div>

      <!-- Logo -->
      <div class="mb-2">
        <label class="form-label">{{ 'CUSTOMIZATION.SHORTS.LOGO_COLOR' | translate }}</label>
        <div class="d-flex flex-wrap gap-2" id="shortLogoColor">
          <span
            [id]="color + '-shortLogo'"
            *ngFor="let color of colors"
            [ngStyle]="{ background: color }"
            class="color-circle"
            [ngClass]="{ active: shortSelections.logoColor === color }"
            (click)="applyLogoColor(color)"
          ></span>
        </div>
        <div *ngIf="hasError('SHORT.LOGO_COLOR_REQUIRED')" class="text-danger mt-2">
          {{ 'CUSTOMIZATION.VALIDATION.SHORT_LOGO_COLOR_REQUIRED' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
